import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Pagination, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { faInfoCircle, faListUl } from "@fortawesome/free-solid-svg-icons";

import Banner from "../components/Banner";
import CatalogFiltersList from "../components/CatalogFiltersList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HelmetSeo from "../components/Reusable/HelmetSeo";
import ListProductsItem from "../components/ListProductsItem";
import Loader from "../components/Reusable/Loader";
import { useSelector } from "react-redux";
import { fetchCatalogItemFilters, fetchCatalogItems } from "../actions/global";
import { useDispatch } from "react-redux";

const Catalog = () => {
  const { key, value } = useParams();
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [numberPerPage, setNumberPerPage] = useState(15);
  const [categoryName, setCategoryName] = useState("");

  const params = new URLSearchParams(location.search);
  const ascParam = params.get("asc");

  const openSidebarFilter = () => {
    document.body.classList.add("sidebar-active");
  };

  // Add a second foo parameter.
  const queryParams = {};
  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  const {
    dataProductsList,
    dataCatalogPaginationList,
    dataCatalogFiltersList,
    loadingCatalog,
    loadingFilterList,
    dateCategoriesList,
  } = useSelector((state) => state.globalReducer);

  const [currentPage, setCurrentPage] = useState(queryParams.page);
  const [orderCatalog, setOrderCatalog] = useState(ascParam === "true");

  const handleSortChange = (e) => {
    const newOrder = e.target.value === "true";
    setOrderCatalog(newOrder);

    // ažuriraj query parametar
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("asc", newOrder);

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(searchParams.get("page")) || 0;
    setCurrentPage(pageFromUrl);
  }, [location.search]);

  //prvo ucitavanje
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ascParam = params.get("asc");
    setOrderCatalog(ascParam === "true");
  }, [location.search]);

  const handlePageChange = (event, value) => {
    const searchParams = new URLSearchParams(location.search);

    // value je 1-based iz MUI → prebaci ga u 0-based
    searchParams.set("page", value - 1);

    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  //dohvatanje proizvoda po kategoriji
  useEffect(() => {
    dispatch(fetchCatalogItemFilters(value));
  }, [dispatch, value]);

  return (
    <>
      <HelmetSeo
        title={`${categoryName} | UP-IT Shop`}
        description={`opis`}
        keywords={`keys`}
      />
      <nav className="breadcrumb-nav">
        <div className="container1">
          <ul className="breadcrumb bb-no">
            <li>
              <Link to="/">Pocetna -</Link>
            </li>
            <li>
              <a>Katalog -</a>
            </li>
            <li>{categoryName}</li>
          </ul>
        </div>
      </nav>
      <div className="page-content">
        <div className="container1">
          <div className="shop-content row gutter-lg mb-10">
            <aside className="sidebar shop-sidebar sticky-sidebar-wrapper sidebar-fixed">
              <div className="sidebar-overlay"></div>
              {/* <a className="sidebar-close" onClick={closeSidebarFilter}>
                <i className="close-icon"></i>
              </a> */}

              <div className="sidebar-content scrollable">
                <div className="sticky-sidebar">
                  <CatalogFiltersList
                    dataCatalogFiltersList={dataCatalogFiltersList}
                    categoryId={value}
                  />
                </div>
              </div>
            </aside>
            <div className="main-content">
              <nav className="toolbox sticky-toolbox sticky-content fix-top">
                <div className="toolbox-left">
                  <a
                    className="btn btn-primary btn-outline btn-rounded left-sidebar-toggle 
                                        btn-icon-left d-block d-lg-none"
                    onClick={openSidebarFilter}
                  >
                    <FontAwesomeIcon icon={faListUl} />
                    {/* <span>Filteri</span> */}
                  </a>
                  <div className="toolbox-item toolbox-sort select-box text-dark custom-title-category">
                    <div className="serach-box-item-content-text">
                      <b>{categoryName}</b>
                    </div>
                  </div>
                </div>
                <div className="toolbox-right">
                  <div className="toolbox-item toolbox-show select-box">
                    <label>Sortiraj po :</label>
                    <select
                      name="orderby"
                      className="form-control"
                      value={orderCatalog}
                      style={{ width: "150px" }}
                      onChange={(e) => handleSortChange(e)}
                    >
                      <option value={false}>Cena opadajuće</option>
                      <option value={true}>Cena rastuće</option>
                    </select>
                  </div>
                </div>
              </nav>
              <div className="row">{/* <Banner /> */}</div>
              {loadingCatalog ? (
                <Loader />
              ) : (
                <div className="product-wrapper row cols-md-3 cols-sm-2 cols-1">
                  {dataProductsList.length > 0 ? (
                    <>
                      {dataProductsList?.map((item, key) => (
                        <div className="product-wrap" key={key}>
                          <ListProductsItem item={item} />
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="col-12">
                      <div className="alert alert-icon alert-primary alert-bg alert-inline show-code-action">
                        <h4 className="alert-title">
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </h4>{" "}
                        Trenutno nemamo proizvode iz ove kategorije
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="toolbox toolbox-pagination justify-content-center">
                <Stack spacing={2}>
                  <Pagination
                    count={dataCatalogPaginationList?.totalPages}
                    page={parseInt(currentPage) + 1}
                    onChange={handlePageChange}
                    showFirstButton
                    showLastButton
                    size="large"
                  />
                </Stack>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Catalog;
